// extracted by mini-css-extract-plugin
export default {"labelsContainer":"GameLabels__labelsContainer--mJQ","label":"GameLabels__label--2lz","shine":"GameLabels__shine--fc_"};